import React, { useEffect, useState } from 'react';
import { Form, FormFeedback, Input, Label } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { Campaign } from '../../types/campaign';
import { updateCampaignClickTag } from '../../api/campaignApi';

interface UpdateCampaignClickTagModalProps {
    campaign: Campaign;
    isOpen: boolean;
    toggle: () => void;
    onUpdateData: (data: Campaign) => void;
}

const UpdateCampaignClickTagModal = ({ campaign, isOpen, toggle, onUpdateData }: UpdateCampaignClickTagModalProps) => {
    const [loading, setLoading] = useState<boolean>(false);

    const toggleModal = () => {
        toggle();
    };

    const handleForm: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            file: undefined,
        },
        validationSchema: Yup.object({
            file: Yup.mixed().required("É necessário um arquivo csv")
        }),
        onSubmit: (values: any) => {
            setLoading(true);
            const formData = new FormData();
            const file: HTMLInputElement | null = document.querySelector('#file-field');
            if (file && file.files) {
                formData.append('file', file.files[0]);
            }
            updateCampaignClickTag(campaign.id, formData)
                .then((res: any) => {
                    toggleModal();
                    onUpdateData(res);
                    toast.success('Campanha atualizada com sucesso!');
                })
                .catch(() => {
                })
                .finally(() => {
                    setLoading(false);
                });
        },
    });

    return (
        <div className={`modal ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }} tabIndex={-1}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <Form onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleForm.handleSubmit();
                        return false;
                    }}>
                        <div className="modal-header bg-light p-3">
                            <h5 className="modal-title">Atualizar URL dos pedidos</h5>
                            <button type="button" className="btn-close" onClick={toggleModal}></button>
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <Label
                                    htmlFor="file-field"
                                    className="form-label"
                                >
                                    Pedidos
                                </Label>
                                <Input
                                    className="form-control"
                                    type="file"
                                    id="file-field"
                                    name="file"
                                    accept=".csv"
                                    onChange={handleForm.handleChange}
                                    onBlur={handleForm.handleBlur}
                                    value={handleForm.values.file}
                                    invalid={
                                        !!(handleForm.touched.file && handleForm.errors.file)
                                    }
                                />
                                {handleForm.touched.file && handleForm.errors.file ? (
                                    <FormFeedback
                                        type="invalid">{handleForm.errors.file}</FormFeedback>
                                ) : null}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="submit"
                                className="btn btn-success btn-label right ms-auto nexttab nexttab"
                            >
                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                {loading && <span className="spinner-border spinner-border-sm me-2" role="status"
                                                  aria-hidden="true"></span>}
                                Atualizar
                            </button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default UpdateCampaignClickTagModal;